import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DISPATCHER_PREFIX} from '../../../../../../../mx-core/src/lib/consts/data-service-consts';

@Injectable({
    providedIn: 'root'
})
export class PrlForgotPasswordService {

    constructor(
        private httpClient: HttpClient
    ) {
    }

    public forgotPassword(userName: string, email: string): Observable<void> {
        return this.httpClient.put<void>(`${DISPATCHER_PREFIX}/login/password/forgot`,
            {
                username: userName,
                email: email
            });
    }

    public getUsernameByLink(link: string): Observable<string> {
        return this.httpClient.get(`${DISPATCHER_PREFIX}/reset/username-by-link/${link}`, {responseType: 'text'});
    }

    public updatePassword(newPassword: string, token: string, username: string): Observable<void> {
        return this.httpClient.post<void>(`${DISPATCHER_PREFIX}/reset/password`,
            {
                newPassword: newPassword,
                token: token,
                username: username
            });
    }

    public forceChangePassword(newPassword: string): Observable<void> {
        return this.httpClient.post<void>(`${DISPATCHER_PREFIX}/login/password/force-change`, {
            password: newPassword
        });
    }
}
